__turbopack_context__.v({
  "collection": "la1ddW_collection",
  "collection-add": "la1ddW_collection-add",
  "collection-card-hit": "la1ddW_collection-card-hit",
  "collection-container": "la1ddW_collection-container",
  "collection-content": "la1ddW_collection-content",
  "collection-image": "la1ddW_collection-image",
  "collection-images": "la1ddW_collection-images",
  "collection-loader": "la1ddW_collection-loader",
  "collection-subtitle-account": "la1ddW_collection-subtitle-account",
  "collection-title": "la1ddW_collection-title",
});
